import { render, staticRenderFns } from "./OrderPurcharseAttention.vue?vue&type=template&id=511bc542&"
import script from "./OrderPurcharseAttention.vue?vue&type=script&lang=js&"
export * from "./OrderPurcharseAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports